import { useMutation, useQueryClient } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";
import { useAuth } from "@/shared/hooks/useAuth";
import { useAppContext } from "@/shared/hooks/useAppContext";

interface RevokeTpaParams {
  signatureType: "tpa" | "irs";
  reason?: string;
}

interface RevokeTpaResponse {
  success: boolean;
  message: string;
  revokedAt: string;
}

export function useRevokeTPA() {
  const queryClient = useQueryClient();
  const { user: authUser } = useAuth();
  const { person } = useAppContext();

  return useMutation({
    mutationFn: async ({ signatureType, reason }: RevokeTpaParams): Promise<RevokeTpaResponse> => {
      const { data, error } = await supabase.functions.invoke("legal/tpa/revoke", {
        body: {
          signatureType,
          reason,
          estateId: person?.estate_id,
        },
      });

      if (error) throw error;
      return data as RevokeTpaResponse;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["userSettingsSupabase", authUser?.sub] });
    },
  });
}
